import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useCallback,
  useRef,
} from "react";
import { Dropdown } from "primereact/dropdown";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import useEntityOnboarding from "../../../Pages/EntityOnboard/useEntityOnboarding";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllEntites } from "../../../Pages/MyEntityDashboard/myEntityDashboardSlice";
import { Tooltip } from "primereact/tooltip";
import useGeneralInformation from "./UseGeneralInformation";
import { useParams } from "react-router-dom";
// import { setInfoData } from "../../../Pages/EntityOnboard/components/formSlice";
import CountryDropdown from "../../countryDropDown";
import { Skeleton } from "primereact/skeleton";
import { useEntity } from "../../../Pages/Entities";
import TimeZoneDropdown from "~/components/TimeZoneSelector";
import timezoneslist from "../../../assets/timezone-list.json";
import apiService from "~/services/service";
import API_ROUTES from "~/api-routes-v2";
import ToastMessage from "~/components/ToastMessage";

const GeneralInformationForm = (
  {
    isEditing,
    showGeneralInfo,
    formDetails,
    setFormDetails,
    btnToggle,
    setBtnToggle,
    handleFormStateChange,
    resetFormFields,
    setShowDialog,
    setInfoData,
    infoData,
    isSaveDisabled,
    setIsSaveDisabled,
    setIsLoading,
  },
  ref,
) => {
  const { companyType, parentCompanyList, customersList } =
    useEntityOnboarding();

  const {
    tempFormData,
    setTempFormData,
    skipReset,
    setSkipReset,
    resData,
    setResData,
  } = useGeneralInformation();

  const [loading, setLoading] = useState(true);
  const [validationErrors, setValidationErrrors] = useState({});

  // Account Manager states
  const [accountManagers, setAccountManagers] = useState([]);
  const [isLoadingAccountManagers, setIsLoadingAccountManagers] =
    useState(false);
  const [hasFetchedAccountManagers, setHasFetchedAccountManagers] =
    useState(false);
  const toastRef = useRef(null);

  const dispatch = useDispatch();
  const { id } = useParams();
  const data = useEntity();
  const generalTempForm = useSelector(
    (state) => state.generalTempForm.generalTempForm,
  );

  const allentites = useSelector((state) => state.myentitydashboard.allentites);
  const isEntityLoad = useSelector(
    (state) => state.myentitydashboard.isEntityLoad,
  );
  const isOrgLoading = useSelector((state) => state.onboarding.isOrgLoading);
  const generalInformation = useSelector(
    (state) => state.generalInformation.generalInformation,
  );
  const generalInformationStatus = useSelector(
    (state) => state.generalInformation.status,
  );
  const resetForm = useSelector((state) => state.generalInformation.reset);
  useEffect(() => {
    if (resData && resetForm) {
      setTempFormData({
        organization: resData?.tenantData?.id || "",
        parent: resData?.parent || null,
        name: resData?.name || "",
        trading_name: resData?.trading_name || "",
        tax_id: resData?.tax_id || "",
        country: resData?.country || "",
        registration_number: resData.registration_number || "",
        type: resData?.type || "",
        salesforce_id: resData?.salesforce_id || "",
        account_manager_id: resData?.account_manager_id || "",
        account_manager_name: resData?.account_manager_name || "",
        account_manager_email: resData?.account_manager_email || "",
        timezone: resData?.timezone || "",
      });
    }
  }, [resetForm]);
  useEffect(() => {
    if (generalInformation?.data) {
      const accountManagerData = generalInformation?.data?.accountManagerData;
      const processedData = {
        ...generalInformation?.data,
        organization: generalInformation?.data?.tenant_id,
        account_manager_id:
          accountManagerData?.id ||
          generalInformation?.data?.account_manager_id,
        account_manager_name: accountManagerData
          ? accountManagerData.preferred_name ||
            [accountManagerData.given_name, accountManagerData.surname]
              .filter(Boolean)
              .join(" ")
          : generalInformation?.data?.account_manager_name,
        account_manager_email:
          accountManagerData?.email ||
          generalInformation?.data?.account_manager_email,
      };
      setTempFormData(processedData);
      // Also update resData so discard works correctly on first load
      setResData((prev) => ({
        ...prev,
        ...processedData,
        tenantData: { id: generalInformation?.data?.tenant_id },
      }));
    }
  }, [generalInformation?.data]);
  useEffect(() => {
    if (generalInformationStatus === "succeeded") {
      setLoading(false);
    } else if (generalInformationStatus === "loading") {
      setLoading(true);
    }
  }, [generalInformationStatus]);

  // const infoData = useSelector((state) => state.form.infoData);

  const initialDefaultValue = {
    organization: showGeneralInfo
      ? ""
      : infoData?.organization || tempFormData?.organization || "",
    parent: showGeneralInfo
      ? null
      : infoData?.parent || tempFormData?.parent || null,
    name: showGeneralInfo ? "" : infoData?.name || tempFormData?.name || "",
    trading_name: showGeneralInfo ? "" : tempFormData?.trading_name || "",
    tax_id: showGeneralInfo ? "" : tempFormData?.tax_id || "",
    country: showGeneralInfo ? "" : tempFormData?.country || "",
    registration_number: showGeneralInfo
      ? ""
      : tempFormData.registration_number || "",
    type: showGeneralInfo ? "" : tempFormData?.type || "",
    salesforce_id: showGeneralInfo ? "" : tempFormData?.salesforce_id || "",
    account_manager_name: showGeneralInfo
      ? ""
      : tempFormData?.account_manager_name || "",
    account_manager_email: showGeneralInfo
      ? ""
      : tempFormData?.account_manager_email || "",
    timezone: showGeneralInfo ? "" : tempFormData?.timezone || "",
  };
  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      organization: initialDefaultValue.organization || "",
      parent: initialDefaultValue.parent || null,
      name: initialDefaultValue.name || "",
      trading_name: initialDefaultValue.trading_name || "",
      tax_id: initialDefaultValue.tax_id || "",
      country: initialDefaultValue.country || "",
      registration_number: initialDefaultValue.registration_number || "",
      type: initialDefaultValue.type || "",
      salesforce_id: initialDefaultValue.salesforce_id || "",
      account_manager_name: initialDefaultValue.account_manager_name || "",
      account_manager_email: initialDefaultValue.account_manager_email || "",
      timezone: initialDefaultValue.timezone,
    },
  });

  const [validations, setValidations] = useState({});
  useEffect(() => {
    if (tempFormData) {
      reset({
        organization: showGeneralInfo
          ? ""
          : infoData?.organization || tempFormData?.organization || "",
        parent: showGeneralInfo
          ? null
          : infoData?.parent || tempFormData?.parent || null,
        name: showGeneralInfo ? "" : infoData?.name || tempFormData?.name || "",
        trading_name: showGeneralInfo ? "" : tempFormData?.trading_name || "",
        tax_id: showGeneralInfo ? "" : tempFormData?.tax_id || "",
        country: showGeneralInfo ? "" : tempFormData?.country || "",
        registration_number: showGeneralInfo
          ? ""
          : tempFormData.registration_number || "",
        type: showGeneralInfo ? "" : tempFormData?.type || "",
        salesforce_id: showGeneralInfo ? "" : tempFormData?.salesforce_id || "",
        account_manager_name: showGeneralInfo
          ? ""
          : tempFormData?.account_manager_name || "",
        account_manager_email: showGeneralInfo
          ? ""
          : tempFormData?.account_manager_email || "",
        timezone: showGeneralInfo
          ? ""
          : infoData?.timezone || tempFormData?.timezone || "",
      });
    }
  }, [tempFormData]);
  useEffect(() => {
    if (!isEditing && !skipReset) {
      reset(generalTempForm);
    }
  }, [generalTempForm, reset, isEditing]);
  useEffect(() => {
    if (!showGeneralInfo) {
      resetFormFields(reset);
      setSkipReset(true);
    }
  }, [showGeneralInfo, resetFormFields, reset]);

  useEffect(() => {
    if (showGeneralInfo) {
      reset(infoData);
    }
  }, [showGeneralInfo, infoData, reset]);

  const onSubmit = useCallback(
    (data) => {
      // For account manager fields, use tempFormData values since they're updated directly
      // and not fully synced with react-hook-form
      const accountManagerData = showGeneralInfo
        ? {
            account_manager_id: data?.account_manager_id,
            account_manager_name: data?.account_manager_name,
            account_manager_email: data?.account_manager_email,
            account_manager_tenant_id: data?.account_manager_tenant_id,
          }
        : {
            account_manager_id: tempFormData?.account_manager_id,
            account_manager_name: tempFormData?.account_manager_name,
            account_manager_email: tempFormData?.account_manager_email,
            account_manager_tenant_id: tempFormData?.account_manager_tenant_id,
          };

      const submissionData = {
        ...data,
        ...accountManagerData,
      };

      setResData((prev) => ({
        ...prev,
        name: submissionData.name,
        tenantData: { id: submissionData?.organization },
        parent: submissionData?.parent,
        trading_name: submissionData?.trading_name,
        tax_id: submissionData?.tax_id,
        country: submissionData?.country,
        registration_number: submissionData.registration_number,
        type: submissionData?.type,
        salesforce_id: submissionData?.salesforce_id,
        account_manager_id: submissionData?.account_manager_id,
        account_manager_name: submissionData?.account_manager_name,
        account_manager_email: submissionData?.account_manager_email,
        account_manager_tenant_id: submissionData?.account_manager_tenant_id,
        timezone: submissionData?.timezone,
      }));
      setIsLoading(true);
      setFormDetails(submissionData);
      dispatch(setInfoData(submissionData));
      setIsLoading(false);
    },
    [
      showGeneralInfo,
      tempFormData,
      setResData,
      setIsLoading,
      setFormDetails,
      dispatch,
      setInfoData,
    ],
  );

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(fetchAllEntites())
  //     .then(() => {
  //         setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }, [dispatch, id]);

  const handleDialogToggle = () => {
    if (infoData) {
      const hasValue = Object.values(infoData).some((value) => value !== "");
      setShowDialog(hasValue);
    }
  };

  const handleSetBtnDisable = () => {
    const error = Object.keys(errors);
    if (tempFormData?.timezone && !error.length) {
      if (isSaveDisabled) {
        setIsSaveDisabled(!isSaveDisabled);
      }
    }
  };

  const checkErrors = () => {
    if (errors) {
      setValidationErrrors({ ...errors });
    }
  };

  useEffect(() => {
    if (infoData && showGeneralInfo) {
      const isFormValid =
        infoData.organization &&
        infoData.name &&
        infoData.country &&
        infoData.registration_number &&
        infoData.type &&
        infoData.account_manager_email &&
        infoData.account_manager_name &&
        infoData.timezone &&
        isValid;

      setBtnToggle(!isFormValid);
    }

    handleDialogToggle();
  }, [infoData, showGeneralInfo, isValid]);

  useImperativeHandle(ref, () => {
    return {
      submit: handleSubmit(onSubmit),
    };
  }, [handleSubmit, onSubmit]);

  // Fetch account managers from API (lazy loaded on dropdown open)
  const fetchAccountManagers = useCallback(async () => {
    if (hasFetchedAccountManagers || isLoadingAccountManagers) return;

    setIsLoadingAccountManagers(true);
    try {
      const response = await apiService(
        API_ROUTES.FETCH_ACCOUNT_MANAGERS,
        "GET",
      );
      if (response?.data) {
        const managers = response.data.map((manager) => ({
          id: manager.id,
          name:
            manager.preferred_name ||
            [manager.given_name, manager.surname].filter(Boolean).join(" "),
          email: manager.email,
        }));
        setAccountManagers(managers);
      }
      setHasFetchedAccountManagers(true);
    } catch (error) {
      console.error("Failed to fetch account managers:", error);
    } finally {
      setIsLoadingAccountManagers(false);
    }
  }, [hasFetchedAccountManagers, isLoadingAccountManagers]);

  // Handle account manager selection
  const handleAccountManagerSelect = (managerId, field) => {
    const selectedManager = accountManagers.find((m) => m.id === managerId);
    if (selectedManager) {
      // Update both the name (display) and email fields
      if (showGeneralInfo) {
        dispatch(
          setInfoData({
            account_manager_name: selectedManager.name,
            account_manager_email: selectedManager.email,
            account_manager_id: selectedManager.id,
          }),
        );
        field.onChange(managerId);
      } else {
        setTempFormData((prev) => ({
          ...prev,
          account_manager_name: selectedManager.name,
          account_manager_email: selectedManager.email,
          account_manager_id: selectedManager.id,
        }));
        field.onChange(managerId);
      }
      handleSetBtnDisable();

      // Show toast notification
      toastRef.current?.show({
        severity: "success",
        summary: `"${selectedManager.name}"`,
        detail: (
          <span style={{ color: "var(--message-success-color, #1F2937)" }}>
            has been registered as Account Manager
          </span>
        ),
        life: 5000,
        icon: "pi pi-check",
      });
    }
  };

  // Account manager dropdown options - include current account manager from API if not in list
  const accountManagerOptions = (() => {
    const options = accountManagers.map((manager) => ({
      label: manager.name,
      value: manager.id,
    }));

    // Add current account manager from API response if not already in list
    const accountManagerData = generalInformation?.data?.accountManagerData;
    if (accountManagerData?.id) {
      const existsInList = options.some(
        (opt) => opt.value === accountManagerData.id,
      );
      if (!existsInList) {
        const managerName =
          accountManagerData.preferred_name ||
          [accountManagerData.given_name, accountManagerData.surname]
            .filter(Boolean)
            .join(" ");
        options.unshift({
          label: managerName,
          value: accountManagerData.id,
        });
      }
    }

    return options;
  })();

  // Custom item template with radio button style
  const accountManagerItemTemplate = (option) => {
    const currentManagerId = showGeneralInfo
      ? infoData?.account_manager_id
      : tempFormData?.account_manager_id;
    return (
      <div className="flex align-items-center gap-2">
        <RadioButton
          checked={currentManagerId === option.value}
          onChange={() => {}}
          tabIndex={-1}
        />
        <span>{option.label}</span>
      </div>
    );
  };

  useEffect(() => {
    if (!isEditing && !showGeneralInfo) {
      handleFormStateChange(isDirty && isValid);
    }
  }, [isDirty, isValid, isEditing, showGeneralInfo]);

  useEffect(() => {
    const names = allentites?.map((entity) =>
      entity?.name?.toLowerCase().trim(),
    );
    const ids = allentites?.map((entity) => entity?.salesforce_id);
    setValidations({ names: names, ids: ids });
  }, [allentites]);
  useEffect(() => {
    if (!showGeneralInfo && setIsSaveDisabled) {
      setIsSaveDisabled(!isValid);
    }
  }, [isValid]);
  return (
    <>
      {showGeneralInfo && (
        <>
          <div className="formgrid grid">
            <div className="field col-12">
              <p className="general-info">General Information</p>
            </div>
            {/* <div className="field col-6">
              <Tooltip target=".info-icon" />
              <label className="input-label">
                Account Name*
                <span
                  data-pr-tooltip="Select the customer entity under which the entity will be registered"
                  className="info-icon ml-1 pi pi-info-circle"
                />
              </label>
              <Dropdown
                value={infoData.organization}
                onChange={(e) => {
                  dispatch(setInfoData({ organization: e.value }));
                }}
                options={customersList}
                optionLabel="name"
                placeholder="Select customer this entity should be registered under"
                checkmark={true}
                highlightOnSelect={false}
                className="w-full"
                name="organization"
              />

            </div>
            <div className="field col-6">
              <label className="input-label">
                Parent Entity(if applicable)
              </label>
              <Dropdown
                value={infoData.parent_company}
                onChange={(e) => {
                  dispatch(setInfoData({ parent_company: e.value }));
                }}
                options={parentCompanyList}
                optionLabel="name"
                placeholder="Select parent entity"
                checkmark={true}
                highlightOnSelect={false}
                className="w-full"
                name="parentCompany"
              />

            </div> */}
          </div>
        </>
      )}

      <form id="114490" onSubmit={handleSubmit(onSubmit)}>
        <div className="formgrid grid">
          <div className="field col-6 general-info-margin">
            <Tooltip target=".info-icon" />
            <label className="input-label">
              Account Name*
              <span
                data-pr-tooltip="Select the customer entity under which the entity will be registered"
                className="info-icon ml-1 pi pi-info-circle"
              />
            </label>
            <Controller
              name="organization"
              control={control}
              rules={{ required: "Organization is required." }}
              render={({ field }) => {
                const selectedOrganization =
                  customersList?.find((org) => org.code === field.value) ||
                  null;
                return (
                  <Dropdown
                    {...field}
                    loading={isOrgLoading}
                    value={selectedOrganization}
                    onChange={(e) => {
                      const newValue = e.value;

                      if (showGeneralInfo) {
                        dispatch(setInfoData({ organization: newValue.code }));
                      } else if (isEditing) {
                        setTempFormData((prev) => ({
                          ...prev,
                          organization: newValue.code,
                        }));
                      }

                      field.onChange(newValue.code);
                      handleSetBtnDisable();
                    }}
                    options={customersList}
                    optionLabel="name"
                    optionValue="code"
                    placeholder={
                      isOrgLoading
                        ? "Loading"
                        : "Select customer this entity should be registered under"
                    }
                    disabled={!isEditing}
                    className={`w-full ${!isEditing && "dropdown-field"} ${!isEditing && "disable"} ${
                      errors.organization ? "error" : ""
                    }`}
                  />
                );
              }}
            />

            {errors.organization && (
              <small className="error-message">
                {errors.organization.message}
              </small>
            )}
          </div>
          <div className="field col-6 general-info-margin">
            <label className="input-label">Parent Entity(if applicable)</label>
            <Controller
              name="parent"
              control={control}
              render={({ field }) => {
                const selectedParentCompany =
                  parentCompanyList?.find(
                    (company) => company.code === field.value,
                  ) || null;
                return (
                  <Dropdown
                    {...field}
                    loading={isEntityLoad}
                    value={selectedParentCompany}
                    onChange={(e) => {
                      const newValue = e.value;

                      if (showGeneralInfo) {
                        dispatch(setInfoData({ parent: newValue.code }));
                      } else if (isEditing) {
                        setTempFormData((prev) => ({
                          ...prev,
                          parent: newValue.code,
                        }));
                      }
                      handleSetBtnDisable();

                      field.onChange(newValue.code);
                    }}
                    options={parentCompanyList}
                    optionLabel="name"
                    optionValue="code"
                    placeholder={
                      isEntityLoad ? "Loading" : "Select parent entity"
                    }
                    disabled={!isEditing}
                    className={`w-full ${!isEditing && "dropdown-field"} ${!isEditing && "disable"}`}
                  />
                );
              }}
            />
          </div>
          <div className="field col-6 general-info-margin">
            <label className="input-label">Entity Registered Name*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="name"
                  control={control}
                  defaultValues
                  rules={{
                    required: "Entity registered name is required.",
                    validate: (value) => {
                      if (!showGeneralInfo) {
                        if (
                          validations?.names?.includes(value.toLowerCase()) &&
                          value != control._formValues.name
                        ) {
                          return "Entity Registered Name is not available. Please use a different one";
                        } else {
                          return true;
                        }
                      } else {
                        if (validations?.names?.includes(value.toLowerCase())) {
                          return "Entity Registered Name is not available. Please use a different one";
                        } else {
                          return true;
                        }
                      }
                    },
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      value={
                        showGeneralInfo
                          ? infoData?.name || ""
                          : field.value || ""
                      }
                      onChange={(e) => {
                        if (showGeneralInfo) {
                          const newValue = e.target.value;
                          dispatch(setInfoData({ name: newValue }));
                          field.onChange(newValue);
                        } else {
                          setTempFormData((prev) => ({
                            ...prev,
                            name: e.target.value,
                          }));
                          field.onChange(e.target.value);
                        }
                        handleSetBtnDisable();
                      }}
                      onBlur={checkErrors}
                      type="text"
                      placeholder="Enter legal name"
                      disabled={!isEditing}
                      className={`input-field appearance-none outline-none w-full ${!isEditing && "disable"} ${
                        errors.name ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.name && (
                  <small className="error-message">{errors.name.message}</small>
                )}
                {!errors.name && !isValid && validationErrors?.name && (
                  <small className="error-message">
                    {validationErrors.name.message}
                  </small>
                )}
              </>
            )}
          </div>

          <div className="field col-6 general-info-margin">
            <label className="input-label">Trading Name</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="trading_name"
                  control={control}
                  defaultValues
                  render={({ field }) => (
                    <InputText
                      {...field}
                      value={
                        showGeneralInfo
                          ? infoData?.trading_name || ""
                          : field.value || ""
                      }
                      onChange={(e) => {
                        if (showGeneralInfo) {
                          const newValue = e.target.value;
                          dispatch(setInfoData({ trading_name: newValue }));
                          field.onChange(newValue);
                        } else {
                          setTempFormData((prev) => ({
                            ...prev,
                            trading_name: e.target.value,
                          }));
                          field.onChange(e);
                        }
                        handleSetBtnDisable();
                      }}
                      type="text"
                      placeholder="Enter trading name"
                      disabled={!isEditing}
                      className={`input-field appearance-none outline-none w-full ${!isEditing && "disable"} ${
                        errors.trading_name ? "error" : ""
                      }`}
                    />
                  )}
                />
              </>
            )}
          </div>

          <div className="field col-6 general-info-margin">
            <label className="input-label">Country Of Registration*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="country"
                  control={control}
                  rules={{
                    required: "Country of registration is required.",
                  }}
                  render={({ field }) => (
                    <CountryDropdown
                      {...field}
                      disabled={!isEditing}
                      value={field.value}
                      onChange={(e) => {
                        const newValue = e.value;
                        if (showGeneralInfo) {
                          dispatch(setInfoData({ country: newValue.code }));
                        } else if (isEditing) {
                          setTempFormData((prev) => ({
                            ...prev,
                            country: newValue.code,
                          }));
                        }
                        handleSetBtnDisable();
                        field.onChange(newValue.code);
                      }}
                      error={errors.country}
                      className={`w-full ${!isEditing && "dropdown-field"} ${!isEditing && "disable"} ${
                        errors.country ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.country && (
                  <small className="error-message">
                    {errors.country.message}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="field col-6 general-info-margin time__zone">
            <label className="input-label">Entity time zone*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4" />
            ) : (
              <>
                <Controller
                  name="timezone"
                  control={control}
                  rules={{
                    required: "Time zone is required.",
                  }}
                  render={({ field }) => (
                    <TimeZoneDropdown
                      timezones={timezoneslist}
                      {...field}
                      value={field.value}
                      onChange={(val) => {
                        if (showGeneralInfo) {
                          dispatch(setInfoData({ timezone: val }));
                        } else if (isEditing) {
                          setTempFormData((prev) => ({
                            ...prev,
                            timezone: val,
                          }));
                        }
                        handleSetBtnDisable();
                        field.onChange(val);
                      }}
                      disabled={!isEditing}
                      error={errors.timezone}
                      className={`${!isEditing && "disable"} ${!isEditing && "dropdown-field"} ${errors.timezone ? "error" : ""}`}
                    />
                  )}
                />
              </>
            )}
          </div>

          <div className="field col-6 general-info-margin">
            <label className="input-label">Tax ID Number</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="tax_id"
                  control={control}
                  rules={{
                    pattern: {
                      value:
                        /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
                      message: "Includes alphabets numbers and symbols only",
                    },
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      value={
                        showGeneralInfo
                          ? infoData?.tax_id || ""
                          : field.value || ""
                      }
                      onChange={(e) => {
                        if (showGeneralInfo) {
                          const newValue = e.target.value;
                          dispatch(setInfoData({ tax_id: newValue }));
                          field.onChange(newValue);
                        } else {
                          setTempFormData((prev) => ({
                            ...prev,
                            tax_id: e.target.value,
                          }));
                          field.onChange(e);
                        }
                        handleSetBtnDisable();
                      }}
                      type="text"
                      placeholder="Enter Tax ID number"
                      disabled={!isEditing}
                      className={`input-field appearance-none outline-none w-full ${!isEditing && "disable"}`}
                    />
                  )}
                />
                {errors.tax_id && (
                  <small className="error-message">
                    {errors.tax_id.message}
                  </small>
                )}
              </>
            )}
          </div>

          <div className="field col-6 general-info-margin">
            <label className="input-label">Registration Number*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="registration_number"
                  control={control}
                  defaultValues
                  rules={{ required: "Registration number is required." }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      value={
                        showGeneralInfo
                          ? infoData?.registration_number || ""
                          : field.value || ""
                      }
                      onChange={(e) => {
                        if (showGeneralInfo) {
                          const newValue = e.target.value;
                          dispatch(
                            setInfoData({ registration_number: newValue }),
                          );
                          field.onChange(newValue);
                        } else {
                          setTempFormData((prev) => ({
                            ...prev,
                            registration_number: e.target.value,
                          }));
                          field.onChange(e);
                        }
                        handleSetBtnDisable();
                      }}
                      type="text"
                      placeholder="Enter Registration number"
                      disabled={!isEditing}
                      className={`input-field appearance-none outline-none w-full ${!isEditing && "disable"} ${
                        errors.registration_number ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.registration_number && (
                  <small className="error-message">
                    {errors.registration_number.message}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="field col-12 general-info-margin">
            <label className="input-label">Company Type*</label>
            <div>
              {loading && !showGeneralInfo ? (
                <Skeleton className="p-4"></Skeleton>
              ) : (
                <>
                  <Controller
                    name="type"
                    control={control}
                    rules={{ required: "Company type is required." }}
                    render={({ field }) => {
                      const typeObject = field.value
                        ? { name: field.value, code: field.value }
                        : null;

                      return (
                        <Dropdown
                          {...field}
                          value={typeObject}
                          onChange={(e) => {
                            const newValue = e.value;

                            if (showGeneralInfo) {
                              dispatch(setInfoData({ type: newValue.code }));
                            } else if (isEditing) {
                              setTempFormData((prev) => ({
                                ...prev,
                                type: newValue.code,
                              }));
                            }
                            handleSetBtnDisable();

                            field.onChange(newValue.code);
                          }}
                          options={
                            companyType?.length
                              ? companyType
                              : typeObject
                                ? [typeObject]
                                : []
                          }
                          optionLabel="name"
                          optionValue="code"
                          placeholder="Select Company Type"
                          disabled={!isEditing}
                          className={`w-full ${!isEditing && "dropdown-field"} ${!isEditing && "disable"} ${
                            errors.type ? "error" : ""
                          }`}
                        />
                      );
                    }}
                  />

                  {errors.type && (
                    <small className="error-message">
                      {errors.type.message}
                    </small>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="field col-12 general-info-margin">
            <label className="input-label">Salesforce ID</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="salesforce_id"
                  control={control}
                  defaultValues
                  rules={{
                    pattern: {
                      value: /^[A-Za-z0-9]*$/,
                      message: "Includes alphabets and numbers only",
                    },
                    validate: (value) =>
                      validations?.ids?.includes(value.toLowerCase()) &&
                      value != "" &&
                      value != control._formValues.salesforce_id
                        ? "Id is already registered"
                        : true,
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      value={
                        showGeneralInfo
                          ? infoData?.salesforce_id || ""
                          : field.value || ""
                      }
                      onChange={(e) => {
                        if (showGeneralInfo) {
                          const newValue = e.target.value;
                          dispatch(setInfoData({ salesforce_id: newValue }));
                          field.onChange(newValue);
                        } else {
                          setTempFormData((prev) => ({
                            ...prev,
                            salesforce_id: e.target.value,
                          }));
                          field.onChange(e);
                        }
                        handleSetBtnDisable();
                      }}
                      type="text"
                      placeholder="Enter Salesforce ID"
                      disabled={!isEditing}
                      className={`input-field appearance-none outline-none w-full ${!isEditing && "disable"} ${
                        errors.salesforce_id ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.salesforce_id && (
                  <small className="error-message">
                    {errors.salesforce_id.message}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="field col-6 general-info-margin">
            <label className="input-label">Account Manager*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="account_manager_id"
                  control={control}
                  rules={{
                    required: "Account manager is required.",
                  }}
                  render={({ field }) => (
                    <Dropdown
                      id="account_manager_id"
                      name="account_manager_id"
                      value={
                        showGeneralInfo
                          ? infoData?.account_manager_id || null
                          : tempFormData?.account_manager_id || null
                      }
                      onChange={(e) =>
                        handleAccountManagerSelect(e.value, field)
                      }
                      onShow={() => {
                        fetchAccountManagers();
                      }}
                      options={accountManagerOptions}
                      optionLabel="label"
                      optionValue="value"
                      className={`w-full ${
                        errors.account_manager_id ? "p-invalid" : ""
                      }`}
                      disabled={!isEditing}
                      placeholder="Select Account Manager"
                      appendTo={document.body}
                      filter
                      filterPlaceholder=""
                      showFilterClear={false}
                      itemTemplate={accountManagerItemTemplate}
                      panelClassName={`account-manager-panel ${
                        isLoadingAccountManagers
                          ? "account-manager-panel-loading"
                          : ""
                      }`}
                      emptyMessage="No Account Manager available yet"
                      emptyFilterMessage="No Account Managers found."
                      filterInputAutoFocus={false}
                    />
                  )}
                />
                {errors.account_manager_id && (
                  <small className="error-message">
                    {errors.account_manager_id.message}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="field col-6 general-info-margin">
            <label className="input-label">Account Manager Email*</label>
            {loading && !showGeneralInfo ? (
              <Skeleton className="p-4"></Skeleton>
            ) : (
              <>
                <Controller
                  name="account_manager_email"
                  control={control}
                  render={({ field }) => (
                    <div style={{ position: "relative", width: "100%" }}>
                      <InputText
                        {...field}
                        value={
                          showGeneralInfo
                            ? infoData?.account_manager_email || ""
                            : tempFormData?.account_manager_email || ""
                        }
                        readOnly
                        type="email"
                        placeholder="Email address"
                        className={`input-field appearance-none outline-none w-full account-manager-email-readonly ${
                          !isEditing && "disable"
                        }`}
                        tabIndex={-1}
                        style={{ paddingRight: "40px" }}
                      />
                      <i
                        className="pi pi-lock"
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "var(--text-color-secondary)",
                          pointerEvents: "none",
                        }}
                      />
                    </div>
                  )}
                />
              </>
            )}
          </div>
        </div>
      </form>
      <ToastMessage ref={toastRef} />
    </>
  );
};
export default forwardRef(GeneralInformationForm);
